<template>
	<div class="detail-wrap">
		<el-form ref="editForm" :model="commonAttribute">
			<div class="d-header clearfix">
				<div class="fl">
					<i class="el-icon-info" />
					{{ dataId ? '查看' : '新增' }}属性值
				</div>
				<div class="fr">
					<el-button type="primary" plain class="button-sty" @click="$baseReload()" icon="el-icon-refresh-right">重置</el-button>
					<el-button type="primary" class="button-sty" icon="el-icon-check" @click="saveData">保存</el-button>
				</div>
			</div>
			<div class="d-cont">
				<div class="d-item">
					<div class="title first"><b>基本信息</b></div>
					<table class="table-detail">
						<tbody>
							<tr>
								<th>
									<em class="f-red">*</em>
									属性编号
								</th>
								<td>{{ commonAttribute.code }}</td>
								<th>
									<em class="f-red">*</em>
									属性名
								</th>
								<td>{{ commonAttribute.name }}</td>
							</tr>
							<tr>
								<th>
									<em class="f-red">*</em>
									属性值
								</th>
								<td>
									<el-form-item prop="value" :rules="[{ required: true, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="commonAttribute.value" clearable />
									</el-form-item>
								</td>
								<th>属性值编号</th>
								<td>
									<el-form-item v-if="!dataId" prop="sn" :rules="[{ required: false, trigger: 'blur' }]">
										<el-input type="text" autocomplete="off" v-model="commonAttribute.sn" clearable />
									</el-form-item>
									<template v-else>
										{{ commonAttribute.sn }}
									</template>
								</td>
								<td colspan="4"><span class="f-red">注：不填写，自动产生唯一属性值编号</span></td>
							</tr>
							<tr>
								<th>设置</th>
								<td><el-checkbox label="是否启用" v-model="commonAttribute.enabled"></el-checkbox></td>
							</tr>
							<tr>
								<th>创建人</th>
								<td>{{ commonAttribute.createBy }}</td>
								<th>创建时间</th>
								<td>{{ commonAttribute.createDate }}</td>
								<th>更新人</th>
								<td>{{ commonAttribute.modifyBy }}</td>
								<th>更新时间</th>
								<td>{{ commonAttribute.modifyDate }}</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</el-form>
	</div>
</template>

<script>
export default {
	name: 'systemDictEdit',
	props: ['_dataId', 'param'],
	data() {
		return {
			tabIndex: 0,
			isEdit: false,
			showCompanyDialog: false,
			dataId: '',
			commonAttribute: {}
		};
	},
	created() {
		if (this._dataId) this.dataId = this._dataId;
	},
	mounted() {
		var that = this;
		this.getData();
	},
	methods: {
		getData() {
			if (this.dataId) {
				this.isEdit = true;
				this.$http({
					url: USER_PREFIX + `/common_attribute/get`,
					method: `post`,
					data: {
						id: this.dataId
					},
					isLoading: true,
					modalStrictly: true,
					success: res => {
						this.commonAttribute = res.objx || {};
					}
				});
			} else {
				let pName = this.param.name || '';
				let pCode = this.param.code || '';
				this.commonAttribute = {
					name: pName,
					code: pCode,
					enabled: true,
					flag: 1
				};
			}
		},
		saveData() {
			this.$refs.editForm.validate(valid => {
				if (valid) {
					this.$baseConfirm('您确定要保存吗？').then(() => {
						var url = this.isEdit ? USER_PREFIX + '/common_attribute/updateItem' : USER_PREFIX + '/common_attribute/saveItem';
						this.$http({
							url: url,
							method: `post`,
							data: this.commonAttribute,
							isLoading: true,
							success: res => {
								this.$message({
									message: res.content,
									type: 'success',
									duration: 500,
									onClose: t => {
										if (this.isEdit) {
											this.$baseReload();
										} else {
											this.$baseReload({
												updateParam: {
													_dataId: res.objx
												}
											});
										}
									}
								});
							}
						});
					});
				}
			});
		}
	}
};
</script>
